<div
  class="grid cursor-pointer grid-cols-[auto_1fr_40px] justify-between gap-x-2 p-2 pb-4 transition-colors hover:bg-grey-concrete/40 md:grid-cols-[auto_1fr_1fr_40px]"
  (click)="selectGroup()"
>
  <div class="w-0 overflow-hidden"></div>

  <div id="group" [ngClass]="group.attributes.group_type == 'customer' ? 'col-span-1' : 'col-span-2'">
    <div class="ml-2 my-2 flex flex-wrap items-center gap-1">
      <div
        class="py-0.5 px-2 table rounded-full lowercase text-xs font-medium"
        [ngClass]="
          group.attributes.group_type == 'customer' ? 'bg-grey-blue/20 text-grey-blue' : 'bg-primary/20 text-primary'
        "
      >
        {{ groupType }}
      </div>
    </div>
    <div class="ml-3">
      <app-group-display
        [groupName]="group.attributes.name"
        [groupId]="group.attributes.id"
        [enableLink]="false"
      ></app-group-display>

      @if (userType == 'intranet') {
        <div class="font-normal inline-block text-sm">
          {{ primary_contact?.email }}
        </div>
      }
    </div>
  </div>
  @if (
    (group.attributes.group_type == 'customer' && userType == 'sub_distributor') ||
    (['customer', 'sub_distributor_partner'].includes(group.attributes.group_type) && userType == 'intranet')
  ) {
    <div id="parent_group" class="ml-3 max-sm:col-start-2">
      <label class="mt-2 md:mt-8 font-normal">Parent</label>
      <app-group-display
        [groupName]="group.attributes.parent_group_name"
        [groupId]="group.attributes.parent_group_id"
        [enableLink]="false"
      ></app-group-display>
    </div>
  }
  @if (userType != 'intranet') {
    <div id="email" class="ml-3">
      <label class="mt-2 md:mt-8 font-normal">Email</label>
      <div class="font-medium text-sm">
        {{ primary_contact?.email }}
      </div>
    </div>
  }
  <div class="flex flex-row items-center justify-end max-sm:row-start-1 max-sm:col-start-3 max-sm:row-span-2">
    <ion-icon
      name="chevron-forward"
      class="text-3xl text-grey-mid"
      id="group-{{ group.attributes.id }}"
      (click)="selectGroup()"
    ></ion-icon>
  </div>
</div>
